export const SET_QUESTION_FINISHED = 'questions/SET_QUESTION_FINISHED'
export const ADD_QUESTION_FINISHED = 'questions/ADD_QUESTION_FINISHED'
export const GET_FINISHED_QUESTIONS = 'questions/GET_FINISHED_QUESTIONS'
export const GET_FINISHED_QUESTION = 'questions/GET_FINISHED_QUESTION'
